import { render, staticRenderFns } from "./BannerStyle1.vue?vue&type=template&id=338e10a7&scoped=true"
import script from "./BannerStyle1.vue?vue&type=script&lang=js"
export * from "./BannerStyle1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "338e10a7",
  null
  
)

export default component.exports